import { Component, Inject } from '@angular/core';
import { RequestMapper } from '../../request-mapper';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from "@angular/material/icon";
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AddOblateBottomSheetComponent } from '../add-oblate-bottom-sheet/add-oblate-bottom-sheet.component';

@Component({
  selector: 'app-oblate-btn-dialog',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './oblate-btn-dialog.component.html',
  styleUrl: './oblate-btn-dialog.component.scss'
})
export class OblateBtnDialogComponent {

  isAbleToAddDPOnline: boolean = false;
  isAbleToAddDPOffline: boolean = false;
  isAbleToAddSPOnline: boolean = false;
  isAbleToAddSPOffline: boolean = false;
  isMobile: boolean = false;

  showOnlineMessage!: boolean;
  showOfflineMessage!: boolean;
  showSpOnlineMessage!: boolean;
  showSpOfflineMessage!: boolean;


  constructor(private router: Router, private dialogRef: MatDialogRef<OblateBtnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.isAbleToAddDPOnline= this.data.dpOnline;
    this.isAbleToAddDPOffline= this.data.dpOffline;
    this.isAbleToAddSPOnline= this.data.spOnline;
    this.isAbleToAddSPOffline = this.data.spOffline;  
  }

  onClickAddOblate(type: string) {
    // console.log("onclickaddOblate called, Type:", type);
    if (type === 'online') {
      this.router.navigateByUrl(`/${RequestMapper.ADD_NEW_OBLATE_ONLINE}`);
    }

    if (type === 'offline') {
      this.router.navigateByUrl(`/${RequestMapper.LIST_DRAFT_OBLATE}`);
    }

    if (type === 'sp_online') {
      // console.log("swastayani runned",type)
      this.router.navigateByUrl(`/${RequestMapper.ADD_NEW_SP_ONLINE}`);
    }

    if (type === 'sp_offline') {
      // console.log("swastayani runned")
      this.router.navigateByUrl(`/${RequestMapper.ADD_NEW_SP_OFFLINE}`);
    }

    this.dialogRef.close()
  }


  closeDialog() {
    this.dialogRef.close()
  }
}
